import {
    chainWalk,
    checkInactiveOrDeprecatedAsset,
    convertTableJsonToAsset,
    convertTableJsonToAssetForTrafficLight,
    convertTableJsonToRequestForNDMS,
    getAPIGatewayPostRequest,
    getNodeId,
} from "../../../util/Util";
import {
    ACTIVE,
    ALERT_ASSET_STATUS_MESSAGE, ALERT_PUBLISH_TRAFFIC_LIGHT_COMMAND_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET,
    DEPRECATED,
    ENDPOINT_PUBLISH_TRAFFIC_LIGHT_COMMAND_TO_THIN_CLIENT, MODAL_ERROR,
    TRAFFIC_LIGHT_CONTROLLER_ASSET_TYPE
} from "../../../util/Constants";
import {addAsset, getAssetByAssetLabel, getAssets, setAssetStatus, updateAsset} from "../../../resources/AssetResource";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";

export function fetchTrafficLightControllerDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: TRAFFIC_LIGHT_CONTROLLER_ASSET_TYPE
    }

    getTrafficLightDeviceDetails(dispatcher, request);
}

async function filterTrafficLightDeviceInformation(getAssetsResult) {
    let filteredDeviceInformation = []
    if ("data" in getAssetsResult && "assetDetailsList" in getAssetsResult.data) {
        for (const trafficLightDetails of getAssetsResult.data.assetDetailsList) {
            if (trafficLightDetails.assetStatus === ACTIVE) {
                const getAssetByLabelResult = await getAssetByAssetLabel(trafficLightDetails.assetLabel)
                trafficLightDetails["assetMappings"] = getAssetByLabelResult.data.asset.assetMappings;
                filteredDeviceInformation.push(trafficLightDetails);
            }
        }
    }

    return filteredDeviceInformation;
}

async function getTrafficLightDeviceDetails(dispatcher, request) {
    const getAssetsResult = await getAssets(request.nodeId, request.assetType, null);

    if (getAssetsResult.status === 200) {
        let updatedTrafficLightDeviceInformation = await filterTrafficLightDeviceInformation(getAssetsResult)
        dispatcher({type: "RECEIVE_DATA", data: {"assetDetails": updatedTrafficLightDeviceInformation}});
    } else {
        dispatcher({type: "RECEIVE_DATA", data: {"assetDetails": []}});
    }
}

async function publishTrafficLightCommandToThinClient(dispatcher, request) {
    let args = getAPIGatewayPostRequest(request, ENDPOINT_PUBLISH_TRAFFIC_LIGHT_COMMAND_TO_THIN_CLIENT);
    args.requestBody["nodeId"] = request.nodeId
    const response = await getAPIGatewayDataFromParent(args);

    if (response.status !== 200) {
        dispatcher({type: "SHOW_UPDATE_RESPONSE_MODAL", data: {modalState: MODAL_ERROR, message: ALERT_PUBLISH_TRAFFIC_LIGHT_COMMAND_MESSAGE}})
    }
}

export async function updateTrafficLightDeviceDetails(dispatcher, index, updatedAssetDetails) {
    const request = convertTableJsonToAssetForTrafficLight(updatedAssetDetails, TRAFFIC_LIGHT_CONTROLLER_ASSET_TYPE, ACTIVE)
    const setAssetStatusResponse = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);

    if (setAssetStatusResponse.status !== 200) {
        dispatcher({type: "SHOW_UPDATE_RESPONSE_MODAL", data: {modalState: MODAL_ERROR, message: ALERT_ASSET_STATUS_MESSAGE}})
        return;
    }

    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetResponse = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));

    if(updateAssetResponse.status !== 200) {
        dispatcher({type: "SHOW_UPDATE_RESPONSE_MODAL", data: {modalState: MODAL_ERROR, message: ALERT_UPDATE_ASSET_MESSAGE}})
    } else {
        dispatcher({type: "UPDATE_DATA", data: {"index": index,"assetDetails": updatedAssetDetails}});
    }
}

export async function updateTrafficLightSignalDetails(dispatcher, controllerDataIndex, trafficLightDataIndex, updatedAssetDetails) {
    await updateTrafficLightDeviceDetails(dispatcher, controllerDataIndex, updatedAssetDetails)
    const ndmsRequest = convertTableJsonToRequestForNDMS(trafficLightDataIndex, updatedAssetDetails)
    publishTrafficLightCommandToThinClient(dispatcher, ndmsRequest);
}

export function deleteTrafficLightDeviceDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: DEPRECATED
    }
    setAssetLabelAsDeprecated(dispatcher, request);
}

async function setAssetLabelAsDeprecated(dispatcher, request) {
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            fetchTrafficLightControllerDetails(dispatcher);
        } else {
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

export function addTrafficLightControllerDetails(dispatcher, assetDetails) {
    assetDetails.mac = assetDetails.mac.toLowerCase();
    const request = convertTableJsonToAsset(assetDetails, TRAFFIC_LIGHT_CONTROLLER_ASSET_TYPE, ACTIVE);
    addControllerDetails(dispatcher, request)
}

async function addControllerDetails(dispatcher, request) {
    addAsset(request).then(async result => {
        if (result.status !== 200) {
            const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
            if (!checkInactiveOrDeprecatedAsset(getAssetResult.data.asset.assetDetails.assetStatus)) {
                dispatcher({type: "SHOW_UPDATE_RESPONSE_MODAL", data: {modalState: MODAL_ERROR, message: ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET}})
                return;
            }
            const responseSetAssetStatus = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
            if (responseSetAssetStatus.status !== 200) {
                dispatcher({type: "SHOW_UPDATE_RESPONSE_MODAL", data: {modalState: MODAL_ERROR, message: ALERT_ASSET_STATUS_MESSAGE}})
                return;
            }
            const responseUpdateAsset = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
            if (responseUpdateAsset.status !== 200) {
                dispatcher({type: "SHOW_UPDATE_RESPONSE_MODAL", data: {modalState: MODAL_ERROR, message: ALERT_UPDATE_ASSET_MESSAGE}})
                return;
            }
        }
        fetchTrafficLightControllerDetails(dispatcher)
    })
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/trafficlightdevice/network/TrafficLightOverviewNetworkAPI.js